import api from '../../api'
const state = {
    list: [],
    page: 1,
    perPage: 10,
    total: 0,
    pages: 0,
    query: null
}

const mutations = {
    SET_FOODS (state, value) {
        state.list = value
    },
    SET_CATEGORIES (state, value) {
        let categories = []
        value.forEach(cat => {
            categories.push({value: cat.classification_id, text: cat.title})
        })
        state.categories = categories
    },
    DELETE_FOOD (state, value) {
        state.list.splice(state.list.indexOf(value), 1)
    },
    SET_PAGE (state, value) {
        state.page = value
    },
    SET_TOTAL (state, value) {
        state.total = value
        state.pages = Math.ceil(state.total / state.perPage)
    },
    ADD_FOOD (state, value) {
        state.list.unshift(value)
    },
    UPDATE_SEARCH_QUERY (state, value) {
        state.query = value
    }
}

const actions = {
    loadFoods ({commit, dispatch, state, rootState}, page) {
        commit('SET_PAGE', page || 1)
        dispatch('Global/setLoading', true, {root: true})
        axios.post(rootState.Settings.apiUrl + '/food/load', {perPage: state.perPage, page: state.page, query: state.query})
            .then(function (response) {
                commit('SET_TOTAL', response.data.pagination.total)
                commit('SET_CATEGORIES', response.data.categories)
                commit('SET_FOODS', response.data.data)
                dispatch('Global/setLoading', false, {root: true})
            })
    },
    setFoods ({commit}, value) {
        commit('SET_FOODS', value)
    },
    async deleteFood ({commit, rootState}, data) {
        axios.delete(rootState.Settings.apiUrl + '/food/delete/' + data.id)
            .then(function (response) {
                commit('DELETE_FOOD', data)
            })
    },
    updateSearchQuery ({commit}, query) {
        commit('UPDATE_SEARCH_QUERY', query)
    },
    search ({dispatch, state}) {
        dispatch('loadFoods', state.page)
    }
}

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
